import React from "react";
import OrderTable from "../Table";

const NearCustomer = () => {
  return <OrderTable type="Near Customer" />;
};

export default NearCustomer;
